"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseAPI = undefined;

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _Token = require("../../backend/src/shared/schemas/auth/Token");

var _Token2 = _interopRequireDefault(_Token);

var _AuthProfile = require("../../backend/src/shared/schemas/auth/AuthProfile");

var _AuthProfile2 = _interopRequireDefault(_AuthProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseAPI = exports.BaseAPI = function BaseAPI() {
    _classCallCheck(this, BaseAPI);

    throw new Error("API is a static class and not allowed to be initialized");
};

BaseAPI.login = function (username, password, scope) {
    return {
        url: "api/v1/auth/token",
        parameters: {
            username: username,
            password: password,
            grantType: "password",
            scope: scope
        },
        method: "POST",
        authorization: "noAuth",
        schema: _Token2.default
    };
};
BaseAPI.loginWithRefreshToken = function (refreshToken, scope) {
    return {
        url: "api/v1/auth/token",
        parameters: {
            refreshToken: refreshToken,
            grantType: "refreshToken",
            scope: scope
        },
        method: "POST",
        authorization: "noAuth",
        schema: _Token2.default
    };
};
BaseAPI.getProfile = function (accessToken) {
    return {
        url: "api/v1/auth/profile",
        method: "GET",
        schema: Joi.object().required().keys({
            profile: _AuthProfile2.default.required()
        }),
        authorization: "noAuth",
        headers: {
            "Authorization": "Bearer " + accessToken
        }
    };
};
BaseAPI.resetPassword = function (email) {
    return {
        url: "api/v1/auth/forgot-password",
        method: "POST",
        parameters: {
            username: email
        },
        authorization: "noAuth"
    };
};
exports.default = BaseAPI;


/*****************
 ** WEBPACK FOOTER
 ** ./src/BaseAPI.ts
 ** module id = 628
 ** module chunks = 0
 **/